import { render, staticRenderFns } from "./PlateInfo.vue?vue&type=template&id=6fb134a4&"
import script from "./PlateInfo.vue?vue&type=script&lang=js&"
export * from "./PlateInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlateInfo.vue?vue&type=style&index=0&id=6fb134a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports